<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            style="max-width:36px !important"
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="error">
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
        <span>Delete entry</span>
      </v-tooltip>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ entry.claim_type.name }}</b>? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10" 
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      entry: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.claimRequestEntries().delete(this.entry.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.$snack({ 
                color: 'error',
                message: error.response.statusText, 
              })
            }
          })
          .finally(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
